/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SmsInputs */

const cs_enum_sms = /** @type {(inputs: Enum_SmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS`)
};

const en_enum_sms = /** @type {(inputs: Enum_SmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS`)
};

/**
* | output |
* | --- |
* | "SMS" |
*
* @param {Enum_SmsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sms = /** @type {((inputs?: Enum_SmsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SmsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sms(inputs)
	return cs_enum_sms(inputs)
});